export default __webpack_public_path__ + "static/media/performanceglobalindices-graph.83ba8879.png";